import React, { useEffect } from 'react'

const TOTAL_STEPS = 8

const Sidebar = ({ currentStep = 1, onSelectStep, completedSteps = [], isMobileMenuOpen, setIsMobileMenuOpen }) => {
  
  // Close mobile menu when screen resizes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 993) {
        setIsMobileMenuOpen(false)
        document.body.classList.remove('mobile-menu-open')
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [setIsMobileMenuOpen])

  // Handle body scroll lock
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('mobile-menu-open')
    } else {
      document.body.classList.remove('mobile-menu-open')
    }
  }, [isMobileMenuOpen])

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  const SidebarContent = () => (
    <div className="h-full px-4 py-6">
      <div className="flex flex-col items-center">
        {/* logo area */}
        <div className="mb-6">
          <img src="./../assets/images/Logo-Incredible-Leaders.png" alt="logo" className="w-full h-auto" />
        </div>

        {/* central column for the timeline */}
        <div className="relative w-full flex justify-center">
          <div className="flex flex-col items-center z-10">
            {Array.from({ length: TOTAL_STEPS }).map((_, idx) => {
              const step = idx + 1
              const isActive = step === currentStep
              const isDone = completedSteps.includes(step)
              return (
                <div key={step} className="flex items-center justify-center" id='main_button_steps'>
                  <button onClick={() => onSelectStep?.(step)} className="focus:outline-none">
                    <div className={`flex items-center justify-center rounded-full w-10 h-[40px] text-sm font-semibold mobile_fix ${isActive || isDone ? 'bg-[#FF8E1C] text-white' : 'bg-[#FFF4E5] border border-[#FF8E1C] text-[#FF8E1C]'}`}>
                      {String(step).padStart(2, '0')}
                    </div>
                    <div className="w-[2px] h-[50px] bg-[#FFD7A1] mx-auto my-2 last_hidden"></div>
                  </button>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <>
      {/* Desktop Sidebar - Shows above 993px */}
      <aside className="w-[150px] min-h-screen md-993:block hidden">
        <div className="h-full bg-[#FFF6EB]">
          <SidebarContent />
        </div>
      </aside>

      {/* Mobile Sidebar Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-sidebar-overlay"
          onClick={closeMobileMenu}
        >
          <div 
            className="mobile-sidebar-container w-[280px] h-full bg-white"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-[#FFF6EB] h-full">
              <SidebarContent />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Sidebar